import type { IntlShape } from 'react-intl';

import type { DiscountDurationUnit } from '../discount/redux/types';
import type { PeriodUnit } from '../termedLevel/types';

export function formatDurationUnit(
    durationUnit: DiscountDurationUnit | PeriodUnit | 'days' | 'months' | 'years',
    intl: IntlShape,
    length?: number
) {
    const shouldUseSingular = length === 1;

    const translationKey = shouldUseSingular
        ? `marketplace.durationUnit.${durationUnit.replace(/s$/, '')}`
        : `marketplace.durationUnit.${durationUnit.replace(/s?$/, 's')}`;

    return intl.formatMessage({ id: translationKey });
}
